export const PACKAGE_PAYMENT_CREATE_ORDER_ACTION = "PACKAGE_PAYMENT_CREATE_ORDER_ACTION";
export const PACKAGE_PAYMENT_CREATE_ORDER_SUCCESS = "PACKAGE_PAYMENT_CREATE_ORDER_SUCCESS";

export const PACKAGE_PAYMENT_INIT = "PACKAGE_PAYMENT_INIT";
export const PACKAGE_PAYMENT_FAIL = "PACKAGE_PAYMENT_FAIL";
